import clsx from "clsx"
import { memo } from "react"
import { npPagePxClassName, npPageWidthClassName } from "src/components/np-design/components/constants"
import { NpLogo } from "src/components/np-design/components/NpLogo"
import { routes } from "src/config/routes"
import { SanityAnnouncementData } from "src/data/sanity/types"
import { NpHeaderCartLink } from "./NpHeaderCartLink"
import { NpHeaderIconLink } from "./NpHeaderIconLink"
import { NpHeaderMenuButton } from "./NpHeaderMenuButton"
import { NpHeaderTextLinks } from "./NpHeaderTextLinks"

export type NpHeaderProps = {
  announcement?: SanityAnnouncementData | null
  checkout?: boolean
}

export const NpHeader = memo(({ announcement, checkout }: NpHeaderProps) => {
  return (
    <header aria-label="Navigation" className={clsx(npPagePxClassName, "text-default bg-white/80")}>
      <div
        className={clsx("mx-auto flex h-16 items-center gap-2 lg:h-20 lg:gap-6", npPageWidthClassName, {
          "justify-between": !checkout,
          "justify-center": checkout,
        })}
      >
        <div className="flex items-center gap-2">
          {!checkout && (
            <div className="lg:hidden">
              <NpHeaderMenuButton />
            </div>
          )}
          <div className="text-np-red">
            <NpLogo className="h-16 w-30" />
          </div>
        </div>

        {!checkout && (
          <div className="hidden items-center gap-px lg:flex">
            <NpHeaderTextLinks announcement={announcement} />
          </div>
        )}

        {!checkout && (
          <div className="flex items-center gap-px">
            <NpHeaderIconLink href={routes.search} title="Suche" iconName="search" />
            <NpHeaderCartLink />
          </div>
        )}
      </div>
    </header>
  )
})
